var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_229_17584)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    fill: "#F5D016"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0.253357C7.32711 0.253357 0.253418 7.32704 0.253418 16C0.253418 24.6729 7.32711 31.7466 16 31.7466C24.673 31.7466 31.7467 24.6729 31.7467 16C31.7467 7.32704 24.673 0.253357 16 0.253357ZM11.0937 12.2364C11.1813 12.0546 11.354 11.9462 11.5555 11.9462H13.8209V4.99773C13.8209 4.58286 14.1597 4.24361 14.5746 4.24361H17.4255C17.8404 4.24361 18.1795 4.58286 18.1795 4.99773V11.9462H20.4447C20.6463 11.9462 20.8189 12.0546 20.9066 12.2364C20.9942 12.4179 20.9717 12.6207 20.8461 12.7787L16.4013 18.3636C16.3011 18.49 16.1618 18.557 16.0001 18.557C15.8384 18.557 15.6993 18.49 15.5989 18.3636L11.1543 12.7787C11.0287 12.6207 11.0062 12.4179 11.0938 12.2364H11.0937ZM25.5234 22.0877C25.5234 22.7493 24.9824 23.2904 24.3209 23.2904H7.67917C7.01804 23.2904 6.47673 22.7493 6.47673 22.0877V17.0285C6.47673 16.7662 6.69098 16.5525 6.95292 16.5525H8.64373C8.90586 16.5525 9.12011 16.7665 9.12011 17.0285V20.647H22.8802V17.0285C22.8802 16.7662 23.0942 16.5525 23.3563 16.5525H25.0471C25.3096 16.5525 25.5233 16.7665 25.5233 17.0285L25.5234 22.0877Z",
    fill: "#C21C05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_229_17584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon_download.44ef8df78988217440660098cf6bce4b.svg";
export { ForwardRef as ReactComponent };